<template>
  <Dialog ref="dialog" :title="`${token.id ? 'Edit' : 'New'} Token`">
    <v-form @submit.prevent="save" v-model="valid">
      <v-text-field
          autofocus
          label="Description"
          filled
          v-model="token.description"
          :rules="[v => !!v.trim() || 'Description is required']"
      ></v-text-field>
    </v-form>

    <v-divider class="my-4"></v-divider>

    <div class="d-flex mt-2">
      <v-spacer></v-spacer>

      <v-btn text @click="$refs.dialog.close()">
        Cancel
      </v-btn>

      <v-btn
          text
          color="primary"
          :loading="saving"
          @click="save"
      >
        Save
      </v-btn>
    </div>
  </Dialog>
</template>

<script>
import { NoahTextAPI } from '@/common/noahtext-api';
import Dialog from '@/components/general/Dialog';

export default {
  name: 'TokenEditDialog',
  components: { Dialog },
  props: {
    token: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    saving: false,
    valid: false
  }),
  methods: {
    open() {
      this.$refs.dialog.open();
    },
    close() {
      this.$refs.dialog.close();
    },
    async save() {
      if (!this.valid) return;

      this.saving = true;
      const method = this.token.id ? NoahTextAPI.updateToken : NoahTextAPI.createToken;
      const updated = await method(this.token);
      this.$emit('save', updated);
      this.$refs.dialog.close();
      this.saving = false;
    }
  }
}
</script>

<style scoped>

</style>
